import(/* webpackMode: "eager" */ "/app_next/src/app/error.tsx");
